import {
  ActivityIndicator,
  Alert,
  Image,
  ImageBackground,
  PermissionsAndroid,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppTheme } from "../../utils/theme";
import { AppIcons } from "../../assets/images";
import LinearGradient from "react-native-linear-gradient";
import { useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { useAppSelector } from "../../redux/storeHook";
import {
  AdEventType,
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";
import {
  bannerAdKey,
  getApproxLocation,
  getFCmToken,
  interstitial,
  SOCIAL_LOGIN,
} from "../../utils/contants";
import {
  GoogleSignin,
  statusCodes,
} from "@react-native-google-signin/google-signin";
import axios from "axios";
import { userAction, UserData } from "../../redux/reducers/user";
import appleAuth from "@invertase/react-native-apple-authentication";
import { getMessaging } from "@react-native-firebase/messaging";
import messaging from "@react-native-firebase/messaging";
import { ROUTE_NAME } from "../../utils/routes";
import { setAppOpenAdPaused } from "../../utils/useOpenAppAd";
import DeviceInfo from "react-native-device-info";
import { showToastNotification } from "../../components/global/Toast";

const LoginScreen = () => {
  const route: any = useRoute();
  const roomId = route?.params?.roomId;
  const { userData } = useAppSelector((s) => s.user);
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const bannerRef = useRef<BannerAd>(null);
  const [googleLoading, setGoogleLoading] = useState<boolean>(false);
  const [appleLoading, setAppleLoading] = useState<boolean>(false);

  useForeground(() => {
    if (Platform.OS === "ios") {
      bannerRef.current?.load();
    }
  });

  // useEffect(() => {
  //   const loaded = interstitial.addAdEventListener(AdEventType.LOADED, () =>
  //     console.log("@ interstitial ad loaded"),
  //   );

  //   const opened = interstitial.addAdEventListener(AdEventType.OPENED, () =>
  //     console.log("@ interstitial ad opened"),
  //   );

  //   const closed = interstitial.addAdEventListener(AdEventType.CLOSED, () =>
  //     console.log("@ interstitial ad closed"),
  //   );

  //   // interstitial.load();

  //   return () => {
  //     loaded();
  //     opened();
  //     closed();
  //   };
  // }, []);

  useEffect(() => {
    requestUserPermission();
    // getApproxLocation()
  }, []);

  const configureGoogleSignIn = () => {
    GoogleSignin.configure({
      webClientId:
        "934320258482-6kicel7jj1ebvsnjmjhtas15cv3nm9ip.apps.googleusercontent.com",
      offlineAccess: true,
    });
  };

  useEffect(() => {
    configureGoogleSignIn();
  }, []);

  /**
   * method for login the user uisng social login
   * @author himanshu sharma
   * @param {object} data data that need to login the user
   */
  const handleSocialogin = async (data: any) => {
    // console.log('@ data for google login : ', data);
    try {
      const res = await axios.post(SOCIAL_LOGIN, data);
      // console.log('@ res for google login : ', JSON.stringify(res.data));
      if (res.data?.status) {
        setGoogleLoading(false);
        setAppleLoading(false);
        const {
          _id,
          createdAt,
          email,
          name,
          status,
          updatedAt,
          blockedByAdmin,
          location,
          profilePicture,
        } = res.data?.data?.user as UserData;
        const reduxData: UserData = {
          _id,
          name,
          email,
          status,
          updatedAt,
          createdAt,
          blockedByAdmin,
          location,
          profilePicture,
          access_token: res.data?.data?.token,
        };
        userAction.storeUser(reduxData);
        if (roomId) {
          navigation.replace(ROUTE_NAME.PlayerRoom, { roomId });
        } else {
          navigation.navigate(ROUTE_NAME.HomeScreen);
        }
      }
    } catch (err) {
      setGoogleLoading(false);
      setAppleLoading(false);
      if (axios.isAxiosError(err) && err.response) {
        showToastNotification(
          "",
          err.response.data.message || "An error occurred",
        );
      } else {
        console.log("Unexpected error:", err);
        showToastNotification("", "An unexpected error occurred");
      }
      console.log("@ err in google login : ", err);
    }
  };

  const signInWithGoogle = async () => {
    try {
      setAppOpenAdPaused(true);
      await GoogleSignin.signOut();
      await GoogleSignin.hasPlayServices({
        showPlayServicesUpdateDialog: true,
      });
      const userInfo = await GoogleSignin.signIn();
      if (userInfo?.data != null) {
        const version = DeviceInfo.getVersion();
        const token = await getFCmToken();
        const loc = await getApproxLocation();
        const data = {
          name: userInfo?.data?.user?.name,
          email: userInfo?.data?.user?.email || "",
          device_token: token,
          loginType: "GOOGLE", // GOOGLE or APPLE
          google_id: userInfo?.data?.user?.id, // if GOOGLE
          latitude: loc?.latitude || 28.6139,
          longitude: loc?.longitude || 77.209,
          profilePicture: userInfo?.data?.user?.photo,
          appVersion: version,
          device_type: Platform.OS,

          //"apple_id":"" // if APPLE
        };
        handleSocialogin(data);
        console.log("@ google sign in data : ", userInfo);
      }
    } catch (error: any) {
      console.log("@ Google Sign-in response:", error?.message || error?.code || error);
      setGoogleLoading(false);
      if (error?.code !== statusCodes.SIGN_IN_CANCELLED) {
        showToastNotification("", error?.message || "Sign in failed");
      }
    } finally {
      setAppOpenAdPaused(false, 1000);
      setTimeout(() => {
        setGoogleLoading(false);
      }, 2000);
    }
  };

  const AppleSignIn = async () => {
    try {
      setAppOpenAdPaused(true);
      // Start the sign-in request
      const appleAuthRequestResponse = await appleAuth.performRequest({
        requestedOperation: appleAuth.Operation.LOGIN,
        requestedScopes: [appleAuth.Scope.EMAIL, appleAuth.Scope.FULL_NAME],
      });

      // Extract the necessary info from the response
      const { identityToken, user, email, fullName } = appleAuthRequestResponse;
      if (user) {
        const version = DeviceInfo.getVersion();
        const token = await getFCmToken();
        const loc = await getApproxLocation();
        const data = {
          name: fullName?.givenName || "apple user",
          email: email || "",
          deviceId: Platform.OS,
          device_token: token,
          loginType: "APPLE", // GOOGLE or APPLE
          // google_id: userInfo?.data?.user?.id, // if GOOGLE
          apple_id: user, // if APPLE
          atitude: loc?.latitude || 28.6139,
          appVersion: version,
          longitude: loc?.longitude || 77.209,
          device_type: Platform.OS,
        };
        handleSocialogin(data);
      }
    } catch (error) {
      console.log("Apple Sign-In error:", error);
      setAppleLoading(false);
    } finally {
      setAppOpenAdPaused(false, 1000);
    }
  };

  const fetchFcm = async (): Promise<void> => {
    try {
      const token = await getFCmToken();
      // TODO: Uncomment and integrate: userAction.updateToken(token);
      console.log("FCM Token fetched:", token);
    } catch (err) {
      console.error("@ Error fetching FCM token:", err);
    }
  };

  const requestUserPermission = async (): Promise<void> => {
    try {
      setAppOpenAdPaused(true);
      await requestNotificationPermission();
      const authorizationStatus = await getMessaging().requestPermission();
      if (
        authorizationStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authorizationStatus === messaging.AuthorizationStatus.PROVISIONAL
      ) {
        await fetchFcm();
        console.log("Notification permissions granted!");
      } else {
        console.log("Notification permissions denied!");
      }
    } finally {
      setAppOpenAdPaused(false, 1000);
    }
  };

  const requestNotificationPermission = async (): Promise<void> => {
    if (Platform.OS === "android" && Platform.Version >= 33) {
      try {
        const granted = await PermissionsAndroid.request(
          "android.permission.POST_NOTIFICATIONS",
        );
        if (granted === PermissionsAndroid.RESULTS.GRANTED) {
          console.log("Android notification permission granted");
        } else {
          console.log("Android notification permission denied");
        }
      } catch (err) {
        console.warn("Android permission request error:", err);
      }
    } else {
      console.log("No additional permission needed for this platform");
    }
  };

  const handleGoBack = () => {
    console.log("go_back");
    navigation.goBack();
    userAction.setTouchSound(true);
  };

  return (
    <ImageBackground source={AppIcons.LoginBack} style={styles.mainView}>
      <TouchableOpacity
        style={styles.backButton}
        onPress={handleGoBack}
        activeOpacity={0.7}
      >
        <Image
          source={AppIcons.BackIcon}
          style={styles.backIcon}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Image
          source={AppIcons.Logo}
          style={styles.logo}
          resizeMode="contain"
        />
        <View>
          <Text style={styles.text}>Let’s Get Started</Text>
          <Text style={styles.subText}>Signin to start playing now</Text>
        </View>
        {/* ----- GOOGLE BUTTON ----- */}
        {userData?.access_token ? (
          <>
            <View style={styles.nameView}>
              <Text style={styles.name}>Hii, {userData?.name}</Text>
            </View>
          </>
        ) : (
          <>
            <TouchableOpacity
              onPress={() => {
                setGoogleLoading(true);
                userAction.setTouchSound(true);
                signInWithGoogle();
              }}
              activeOpacity={1}
              style={styles.googleWrapper}
            >
              <LinearGradient
                colors={[
                  AppTheme.colors.linearGradient_5,
                  AppTheme.colors.linearGradient_6,
                ]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={styles.googleBtn1}
              >
                <LinearGradient
                  colors={[
                    AppTheme.colors.linearGradient_1,
                    AppTheme.colors.linearGradient_2,
                  ]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                  style={styles.googleBtn}
                >
                  {googleLoading ? (
                    <ActivityIndicator
                      size={"small"}
                      color={AppTheme.colors.black}
                    />
                  ) : (
                    <View style={styles.row}>
                      <Image
                        source={AppIcons.Google}
                        style={styles.googleIcon}
                        resizeMode="contain"
                      />
                      <Text style={styles.googleText}>
                        Continue with Google
                      </Text>
                    </View>
                  )}
                </LinearGradient>
              </LinearGradient>
            </TouchableOpacity>
            {/* ----- APPLE BUTTON ----- */}
            {Platform.OS == "ios" && (
              <TouchableOpacity
                onPress={() => {
                  setAppleLoading(true);
                  userAction.setTouchSound(true);
                  AppleSignIn();
                }}
                activeOpacity={1}
                style={styles.appleWrapper}
              >
                <LinearGradient
                  colors={[
                    AppTheme.colors.linearGradient_5,
                    AppTheme.colors.linearGradient_6,
                  ]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                  style={styles.googleBtn1}
                >
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.googleBtn}
                  >
                    {appleLoading ? (
                      <ActivityIndicator
                        size={"small"}
                        color={AppTheme.colors.black}
                      />
                    ) : (
                      <View style={styles.row}>
                        <Image
                          source={AppIcons.Apple}
                          style={styles.appleIcon}
                          resizeMode="contain"
                        />
                        <Text style={styles.googleText}>
                          Continue with Apple
                        </Text>
                      </View>
                    )}
                  </LinearGradient>
                </LinearGradient>
              </TouchableOpacity>
            )}
          </>
        )}
      </View>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};

export default LoginScreen;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
  },
  logo: {
    width: 200,
    height: 200,
    alignSelf: "center",
  },
  backButton: {
    position: "absolute",
    top: 70,
    right: 0,
    width: 50,
    height: 40,
    zIndex: 10,
  },
  backIcon: {
    width: 50,
    height: 40,
  },
  text: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    marginTop: 40,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  subText: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_REGULAR,
    fontSize: 14,
    marginTop: 10,
  },
  googleWrapper: {
    alignSelf: "center",
    marginTop: 50,
  },
  appleWrapper: {
    alignSelf: "center",
    marginTop: 30,
  },
  googleBtn: {
    width: 300,
    height: 50,
    borderRadius: 25,
    justifyContent: "center",
  },

  googleBtn1: {
    width: 300,
    height: 55,
    borderRadius: 25,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  googleIcon: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
  appleIcon: {
    width: 35,
    height: 35,
    marginRight: 10,
  },
  googleText: {
    fontFamily: AppTheme.fonts.ALEXANDRIA_REGULAR,
    fontSize: 16,
    color: AppTheme.colors.black,
    textAlign: "center",
  },
  nameView: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    marginTop: 20,
  },
  name: {
    fontSize: 24,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
